export default __webpack_public_path__ + "static/media/RR_Software_SlideAB.0df7da98.png";